import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-of-use',
  imports: [CommonModule],
  templateUrl: './terms-of-use.html',
  styleUrl: './terms-of-use.css'
})
export class TermsOfUseComponent {

}
